import { render, staticRenderFns } from "./BatteryBarChart.vue?vue&type=template&id=052ffa37&scoped=true&"
import script from "./BatteryBarChart.vue?vue&type=script&lang=js&"
export * from "./BatteryBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052ffa37",
  null
  
)

export default component.exports